import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'currencyformat'
})

// Pipe contém o padrão de internacional de moeda, compatível com MS Edge, padrão R$0.00
export class CurrencyFormatPipe implements PipeTransform {

  transform(value: number, currencyCode: string = 'BRL', symbolDisplay: boolean = true, digits?: string): string {

    try {

      if (!value) {
        return '';
      }

      const currencyPipe: CurrencyPipe = new CurrencyPipe('pt-BR');
      const newValue: string = currencyPipe.transform(value, currencyCode, symbolDisplay, digits);

      return newValue;
    } catch (error) {

    }

  }
}



// WEBPACK FOOTER //
// ./src/app/resources/pipes/currency-format.pipe.ts